import React from "react";
import { AHText, Box, ColorType, Space } from "arkh";

export function WorkspaceDetailHeader(props: {
  titleIcon?: React.ReactNode;
  spaceTop?: Space;
  spaceBottom?: Space;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  right?: React.ReactNode;
  color?: ColorType;
}) {
  return (
    <Box
      spaceBottom={props.spaceBottom ?? "medium"}
      spaceTop={props.spaceTop ?? "large"}
      color={props.color ?? "background"}
    >
      <Box
        spaceBottom="medium"
        spaceLeft="medium"
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        {props.titleIcon ? (
          <Box spaceRight="small">{props.titleIcon}</Box>
        ) : null}
        <AHText type="title-big" style={{ flex: 1 }}>
          {props.title}
        </AHText>
        {props.right}
      </Box>
    </Box>
  );
}
